import { render, staticRenderFns } from "./organuser.vue?vue&type=template&id=b4bace22&scoped=true&"
import script from "./organuser.vue?vue&type=script&lang=js&"
export * from "./organuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bace22",
  null
  
)

export default component.exports